// @flow
import PlainBadge from 'app/common/ui-next/plain-badge';

export default PlainBadge;
